import { createFileRoute } from "@tanstack/react-router";
import { SynonymsTab } from "./settings.catalog";

export const Route = createFileRoute("/settings/catalog/synonyms")({
	component: SynonymsTab,
});
